import { createAction } from "redux-actions";

export const OPEN_MODAL = "app/modal/OPEN";
export const CLOSE_MODAL = "app/modal/CLOSE";

export const openModal = createAction(OPEN_MODAL, id => id);
export const closeModal = createAction(CLOSE_MODAL, id => id);
